import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: 'Does this work if I have a Bankruptcy or Eviction?',
    a: 'Yes. The Metro 2 method is based on data accuracy. If the bureau cannot verify every single data point of the eviction (which they almost never can), they MUST delete it.'
  }, {
    q: 'Is this legal?',
    a: "100%. We use the Fair Credit Reporting Act (FCRA). We aren't doing anything shady; we are forcing the banks to follow federal law."
  }, {
    q: 'How soon will I see results?',
    a: 'Most users see the first changes on their report between 14 and 30 days after mailing the first round of letters.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-[#050508]" data-id="element-51">
      <div className="max-w-3xl mx-auto" data-id="element-52">
        <div className="text-center mb-12" data-id="element-53">
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-54">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4" data-id="element-55">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="border border-white/10 rounded-xl overflow-hidden bg-[#0a0a0f]" data-id="element-56">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-57">
                <span className="text-lg font-semibold text-white pr-4" data-id="element-58">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-59" />
              </button>
              <AnimatePresence data-id="element-60">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-61">
                    <div className="p-6 pt-0 text-gray-400 leading-relaxed border-t border-white/5 mt-2" data-id="element-62">
                      <span className="text-green-500 font-bold mr-2" data-id="element-63">✅</span>
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}